import { PartnerInstanceState } from 'commons/types/partnerInstanceTypes';

export const getQuestionnaireSubmissionStatus = (state: any): string =>
  state.myRecommendations.questionnaireSubmission.status;
export const getSurveytoken = (state: any) => state.myRecommendations.surveyToken;
export const getGlobalPartner = (state: { partnerInstance: PartnerInstanceState }) =>
  state.partnerInstance.globalPartner;
